import React from 'react';
import Select from 'react-select';

import {
  TimelineHintDeadlineEnum,
  TimelineHintDeadlineObj,
} from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../translations';

import { Option } from './Selector';

export interface DeadLineSelectorProps {
  onChange: (option: Option) => void;
  deadline?: TimelineHintDeadlineEnum;
  readOnly?: boolean;
  value?: string;
}

export default (props: DeadLineSelectorProps) => {
  const { t, tk } = useTranslation('projectLng');

  const deadlineOptions = Object.entries(TimelineHintDeadlineEnum)
    .map(([key, value]) => ({
      value: key as TimelineHintDeadlineEnum,
      label: t(TimelineHintDeadlineObj[value]),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
  return (
    <Select
      className="full-width"
      value={
        props.deadline
          ? deadlineOptions.find(({ value }) => props.deadline === value)
          : null
      }
      options={deadlineOptions}
      onChange={option => props.onChange(option as Option)}
      isDisabled={props.readOnly}
      isClearable={!props.readOnly}
      placeholder={t(tk.component.pointOut)}
    />
  );
};
